import stringReplacer from './string';
export default function (_, mods, value) {
    var sign = (mods.sign && value >= 0) ? '+' : '';
    return stringReplacer('s', mods, sign + Math.floor(value).toString());
}
